import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Plus } from "lucide-react";

/* Botão discreto "+ Novo X" ao lado/abaixo de um campo de seleção. */
export const BtnCadastroRapido = ({ label, onClick, testid }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testid}
    style={{ background: "transparent", border: "none", color: "var(--gold)", fontSize: 11, letterSpacing: ".08em", cursor: "pointer", padding: "6px 0", display: "inline-flex", alignItems: "center", gap: 4 }}
  >
    <Plus size={11} /> {label}
  </button>
);

function Campo({ f, value, onChange, tid }) {
  const props = { value: value ?? "", onChange: e => onChange(e.target.value), "data-testid": tid };
  return (
    <div className="field">
      <label>{f.l}{f.req ? " *" : " (opcional)"}</label>
      {f.opts ? (
        <select {...props}>{f.opts.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}</select>
      ) : (
        <input type={f.type || "text"} {...props} />
      )}
    </div>
  );
}

/* Modal secundário (acima do modal da obra) com o cadastro mínimo de uma entidade.
   Usa a mesma rota POST do cadastro normal e devolve o item criado em onCreated. */
export function CadastroRapidoModal({ cfg, api, onClose, onCreated }) {
  const [form, setForm] = useState(() => Object.fromEntries(cfg.fields.map(f => [f.k, f.opts ? f.opts[0].v : ""])));
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState("");
  const faltando = cfg.fields.some(f => f.req && !String(form[f.k] || "").trim());

  const salvar = async () => {
    setSaving(true);
    setErro("");
    try {
      const body = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, String(v).trim() || null]));
      const novo = await api("post", `/${cfg.endpoint}`, body);
      onCreated(novo);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setErro(typeof d === "string" ? d : "Não foi possível salvar o cadastro.");
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="modal-back" style={{ zIndex: 400 }} onClick={onClose} data-testid={`cadastro-rapido-${cfg.endpoint}`}>
      <div className="modal" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
        <div className="modal-head" style={{ padding: "20px 24px" }}>
          <h3 className="modal-title" style={{ fontSize: 20 }}>Novo <em>{cfg.titulo}</em></h3>
          <button className="modal-close" onClick={onClose} data-testid="cadastro-rapido-fechar">×</button>
        </div>
        <div className="modal-body" style={{ padding: "18px 24px" }}>
          {cfg.fields.map(f => (
            <Campo key={f.k} f={f} value={form[f.k]} onChange={v => setForm(p => ({ ...p, [f.k]: v }))} tid={`cadastro-rapido-${f.k}`} />
          ))}
          {erro && <div style={{ color: "#c47a7a", fontSize: 12, marginTop: 6 }} data-testid="cadastro-rapido-erro">{erro}</div>}
        </div>
        <div className="modal-foot" style={{ padding: "16px 24px" }}>
          <button className="btn btn-ghost" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={salvar} disabled={saving || faltando} data-testid="cadastro-rapido-salvar">
            {saving ? "Salvando…" : "Cadastrar e selecionar"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
